<template>
    <div>
        <div>
            <div>
                <div class="row" style="margin-left: 35px;">
                    <div class="col-md-5">
                        <base-input  label="POS Activity"> 
                            <a-select
                                style="width:100%"
                                placeholder="POS Activity List"
                                v-model="pos_activity"
                            >
                                <a-select-option
                                    v-for="activity in availableActivities"
                                    :key="activity.trans_code"
                                    :value="activity.trans_code"
                                >
                                    {{ activity.pos_activity }}
                                </a-select-option>
                            </a-select>
                        </base-input>
                    </div>
                    <div class="col-md-5">
                        <base-input
                            v-if="isAmountActivity"
                            label="Threshold Amount"
                            type="number"
                            v-model="threshold_amount"
                        />
                        <base-input
                            v-else
                            label="Threshold Count"
                            type="number"
                            v-model="threshold_count"
                        />
                    </div>
                    <div class="col-md-2">
                        <button type="button" class="btn btn-sm btn-primary" style="margin-top: 35px;"  @click.prevent="add" >+ Add </button>
                    </div>
                </div>
                <!-- table -->
                <div class="row">
                    <div class="col-md-6 offset-md-2">
                        <a-table
                            :columns="columns"
                            :dataSource="dataSource"
                            rowKey="trans_code"
                        >
                            <template slot="threshold" slot-scope="text, record">
                                <!-- Deposit / Withdrawal -->
                                <div v-if="isAmountRecord(record)">
                                    <a-input-number
                                        v-model="record.threshold_amount"
                                        :min="1"
                                        :class="{
                                            'has-error':
                                                record.threshold_amount == null ||
                                                record.threshold_amount <= 0
                                        }"
                                    />
                                    <div
                                        v-if="
                                            record.threshold_amount == null ||
                                            record.threshold_amount <= 0
                                        "
                                        class="text-danger"
                                        style="font-size:12px;"
                                    >
                                        Threshold Amount must be greater than 0.
                                    </div>
                                </div>
                                <!--  other activities -->
                                <div v-else>
                                    <a-input-number
                                        v-model="record.threshold_count"
                                        :min="1"
                                        :class="{
                                            'has-error':
                                                record.threshold_count == null ||
                                                record.threshold_count <= 0
                                        }"
                                    />
                                    <div
                                        v-if="
                                            record.threshold_count == null ||
                                            record.threshold_count <= 0
                                        "
                                        class="text-danger"
                                        style="font-size:12px;"
                                    >
                                        Threshold Count must be greater than 0.
                                    </div>
                                </div>
                            </template>
                            <template slot="action" slot-scope="text, record">
                                <a-button
                                    size="small"
                                    type="danger"
                                    @click="remove(record)"
                                >
                                    Delete
                                </a-button>
                            </template>
                        </a-table>
                    </div>
                    <div class="col-md-2"> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BaseButton from '../../components/BaseButton.vue'
import BaseCheckbox from '../../components/BaseCheckbox.vue'
import { mapState, mapActions } from 'vuex'

let component_x;
export default {
    components: { BaseCheckbox, BaseButton },
    mounted() {
        this.menus = JSON.parse(
            JSON.stringify(this.system_notifications)
        );
        if (this.$attrs.defaultValue) {
            this.$attrs.defaultValue.forEach(saved => {
                const activity = this.menus.find(
                    x => x.trans_code === saved.trans_code
                );
            if (!activity) return;
            if ((saved.trans_code === 'FLT' || saved.trans_code === 'WIT') && saved.threshold_amount == null && saved.threshold_count != null ) {
                activity.threshold_amount = saved.threshold_count;
                activity.threshold_count = null;
                console.log('true', activity)
            } else {
                activity.threshold_count = saved.threshold_count;
                activity.threshold_amount = saved.threshold_amount;
                   console.log('false', activity)
            }
            activity.enabled =
            activity.threshold_count != null ||
            activity.threshold_amount != null;
            });
        }
    },
    computed:{
        ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'categoriesOptions']),
        dataSource() {
            return this.menus
            .filter(activity => activity.enabled)
            .sort((a, b) =>
                a.pos_activity.localeCompare(b.pos_activity)
            );
        },
        availableActivities() {
            return this.menus
            .filter(activity => !activity.enabled)
            .sort((a,b)=>
                a.pos_activity.localeCompare(b.pos_activity)
            );
        },
        isAmountActivity() {
            return (
                this.pos_activity === 'FLT' ||
                this.pos_activity === 'WIT'
            );
        },
        hasValidationError() {
            return this.menus.some(activity => {
                if (this.isAmountRecord(activity)) {
                    return activity.enabled &&
                        (!activity.threshold_amount ||
                        activity.threshold_amount <= 0);
                }
                return activity.enabled &&
                    (!activity.threshold_count ||
                    activity.threshold_count <= 0);

            });
        }
    },
    watch:{
        menus: {
            deep: true,
            handler() {
                const configValues = {};
                configValues[this.$attrs.settingCode] =
                    this.menus.map(activity => {
                        const { enabled, ...item } = activity;
                        return item;
                    });
                this.$emit("changeValue", configValues);
            }
        }
    },
    data(){
        return{
            system_notifications:[
                {trans_code: 'MTBL', pos_activity: "Merge Table", threshold_count: null, threshold_amount: null,  enabled: false},
                {trans_code: 'TTBL', pos_activity: "Transfer Table", threshold_count: null, threshold_amount: null,  enabled: false},
                {trans_code: 'STBL', pos_activity: "Split Table", threshold_count: null, threshold_amount: null,  enabled: false},
                {trans_code: 'SCHK', pos_activity: "Split Check", threshold_count: null, threshold_amount: null,  enabled: false},
                {trans_code: 'LVD', pos_activity: "Void Line", threshold_count: null, threshold_amount: null,  enabled: false},
                {trans_code: 'CAN', pos_activity: "Cancel (Clear All Items)", threshold_count: null, threshold_amount: null,  enabled: false},
                {trans_code: 'TVD', pos_activity: "Void Transaction", threshold_count: null, threshold_amount: null,  enabled: false},
                {trans_code: 'REF', pos_activity: "Refund (Void Transaction After Payment)", threshold_count: null, threshold_amount: null,  enabled: false},
                {trans_code: 'UTRAN', pos_activity: "Unsettled Transaction", threshold_count: null, threshold_amount: null,  enabled: false},
                {trans_code: 'ESDIS', pos_activity: "Exceed Supercard Discount", threshold_count: null, threshold_amount: null,  enabled: false},
                {trans_code: 'EDIS', pos_activity: "Exceed Government Discount", threshold_count: null, threshold_amount: null,  enabled: false},
                {trans_code: 'OPD', pos_activity: "Open Department", threshold_count: null, threshold_amount: null,  enabled: false},
                {trans_code: 'OVR', pos_activity: "Price Override", threshold_count: null, threshold_amount: null,  enabled: false},
                {trans_code: 'FLT', pos_activity: "Deposit (Amount)", threshold_count: null, threshold_amount: null,  enabled: false},
                {trans_code: 'WIT', pos_activity: "Withdrawal (Amount)", threshold_count: null, threshold_amount: null,  enabled: false},
                {trans_code: 'RPN', pos_activity: "Reprint", threshold_count: null, threshold_amount: null,  enabled: false},
                {trans_code: 'RXR', pos_activity: "Reprint x reading", threshold_count: null, threshold_amount: null,  enabled: false},
                {trans_code: 'RZR', pos_activity: "Reprint z reading", threshold_count: null, threshold_amount: null,  enabled: false},
            ],
            menus: [],
            pos_activity: null,
            threshold_count: null,
            threshold_amount: null,
            settingCode: null,
            columns: [
                {
                    title: "POS Activity",
                    dataIndex: "pos_activity",
                    sorter: (a,b)=>a.pos_activity.localeCompare(b.pos_activity)
                },
                {
                    title: "Threshold",
                    dataIndex: "threshold_count",
                    key: "threshold",
                    scopedSlots: {
                        customRender: "threshold"
                    }
                },
                {
                    title: "Action",
                    key: "action",
                    scopedSlots: {
                        customRender: "action"
                    }
                }
            ],
        }
    },
    methods: {
        isAmountRecord(record) {
            return (
                record.trans_code === 'FLT' ||
                record.trans_code === 'WIT'
            );
        },
        add() {
            if (!this.pos_activity)
                return;
            const activity = this.menus.find(
                x => x.trans_code === this.pos_activity
            );
            if (!activity)
                return;
            if (this.isAmountActivity) {
                if (!this.threshold_amount || this.threshold_amount <= 0)
                    return;
                activity.threshold_amount = Number(this.threshold_amount);
                activity.threshold_count = null;
            } else {
                if (!this.threshold_count || this.threshold_count <= 0)
                    return;
                activity.threshold_count = Number(this.threshold_count);
                activity.threshold_amount = null;
            }
            activity.enabled = true;
        },
        remove(record) {
            record.threshold_count = null;
            record.threshold_amount = null;
            record.enabled = false;
        },
    }
}
</script>